import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';

import { IHasIdAndName } from '../../interfaces/has-id-and-name.interface';
import { CollectApiServiceBase } from '../../services/collect-api-base.service';

// Note:  this class was created to hold common code used by component
//        classes FormDetailsComponent and WorkflowDetailsComponent.
@Component({
    template: '',
    standalone: false
})
export abstract class ObjectDetailsBaseComponent {
    // Properties.
    protected objectToEdit: IHasIdAndName = null;
    // Note:  the following EventEmitter properties need to be public
    //        to allow other components to subscribe to their events.
    @Output() protected save: EventEmitter<IHasIdAndName> = new EventEmitter();
    @Output() protected close: EventEmitter<IHasIdAndName> = new EventEmitter();

    protected ngFormGroup: UntypedFormGroup; // naming it this to avoid confusion with Collect's Forms vs NG's Forms

    // Constructor.
    protected constructor(protected fb: UntypedFormBuilder,
        protected service: CollectApiServiceBase<IHasIdAndName>)
    {
        return;
    }

    protected setObjectToEdit(objectToEditParam: IHasIdAndName): void {
        this.objectToEdit = objectToEditParam;
    }

    // Methods called by HTML code.
    public get NgFormGroup(): UntypedFormGroup {
        return this.ngFormGroup;
    }

    public get FormInvalid(): boolean {
        return (!this.ngFormGroup.valid);
    }

    // Methods to handle control events.
    public onSave(): void {
        this.applyEnteredValues();

        this.save.emit(this.objectToEdit);
    }

    public onClose(): void {
        this.close.emit();
    }

    // Helper methods.
    protected setupFormGroup(): void {
        this.ngFormGroup = this.fb.group({
            name: [this.objectToEdit.getName(), Validators.required],
            description: [this.objectToEdit.getDescription()],
            //helpText: [this.form.helpText],
            //helpTextFormat: [this.form.helpTextFormat, Validators.required],
            id: [this.objectToEdit.id]
            //dataCollectionId: [this.objectToEdit.dataCollectionId]
        });
    }

    protected applyEnteredValues(): void {
        this.objectToEdit.setName(this.ngFormGroup.controls.name.value);
        this.objectToEdit.setDescription(this.ngFormGroup.controls.description.value);
    }
}
